export const NOTIFICATION_TYPE = {
    NOTIFICATIONS: 'NOTIFICATIONS',
    ALARMS: 'ALARMS',
    PERSONNEL_EVENT_MANAGED: 'PERSONNEL_EVENT_MANAGED',
    NEW_UNCONFIRMED_PERSONNEL_EVENT: 'NEW_UNCONFIRMED_PERSONNEL_EVENT'
}
